import React, { useState, useEffect, useContext } from "react";
import { Navigate } from 'react-router-dom';
import axios from "axios";
import moment from "moment";
import DataTable from "react-data-table-component";
import { makeStyles } from "@mui/styles";
import LinearProgress from "@mui/material/LinearProgress";
import Tooltip from "@mui/material/Tooltip";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CheckIcon from "@mui/icons-material/Check";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import EditIcon from "@mui/icons-material/Edit";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";
import { CustomSelect } from "components/Input/Index.js";
import UserService from "services/UserService";
import { getActionPlan, deleteAction } from "services/ConfigServices";
import { ActionContext } from "context/ActionContext";
import { IntInput, TextInput } from "components/Input/Index.js";
import useActionTable from "./useActionTable.js";
import { energyType } from "variables/lists/action";

//import "react-table/react-table.css";

// @mui/icons-material

import Button from "components/CustomButtons/Button.js";
import { targetedenergyList } from "variables/lists/action.js";

const useStyles = makeStyles(styles);

const RTEquipments = ({ planActionId, planActionName }) => {
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const actionplanupdate = permis.includes("actionplan_update");
  const { gridState, refreshTable } = useActionTable();
  const appContext = useContext(ActionContext);
  const { action, setAction } = appContext;
  const [editableRowId, setEditableRowId] = useState(false);

  const [newData, setNewData] = useState([]);

  const classes = useStyles();

  useEffect(() => {
    setNewData(gridState.data);
  }, [gridState.data]);

  console.log(action, gridState.data);

  //console.log(actionPlans.parameters.general.groups);

  // if (error) {
  //   return (
  //     <p>
  //       <span role="img" aria-label="Problem">
  //         🔧
  //       </span>{" "}
  //       Oups il semble y avoir un problème...{" "}
  //       <button onClick={refetch}>Réesayer</button>
  //     </p>
  //   );
  // }
  const energy = [];

  function indexFinder(rowId) {
    const indexOfId = newData.findIndex((obj) => obj.uuid == rowId);

    return indexOfId;
  }
  const columns = [
    {
      name: "Nom",
      selector: (row) => row.name,
      sortable: true,
    },
    {
      name: "Usage (Catégorie Système)",
      selector: (row) => row.category,
      sortable: true,
    },
    {
      name: "Source d'énergie",
      selector: (row) => row.energysource,
      sortable: true,
      cell: (row) =>
        editableRowId === row.uuid ? (
          // <TextInput
          //   //inputTitle={actionVar[params].observations}
          //   textInput={newData[indexFinder(row.uuid)].energysource}
          //   handleTextInputChange={(e) => handleChange(e, row.uuid)}
          //   name="energysource"
          // />
          <CustomSelect
            // inputTitle={"Variable " + param.name + " : filtres"}
            selectValue={newData[indexFinder(row.uuid)].energysource}
            handleSelectValueChange={(e) => handleChange(e, row.uuid)}
            data={targetedenergyList}
            name="energysource"
          />
        ) : (
          targetedenergyList.find((energy) => energy.id === row.energysource)
            ?.name
        ),
    },
    {
      name: "Part conso",
      selector: (row) => row.consumptionpart,
      sortable: true,
      cell: (row) =>
        editableRowId === row.uuid ? (
          <IntInput
            //inputTitle={actionVar[params].observations}
            intInput={newData[indexFinder(row.uuid)].consumptionpart}
            handleIntInputChange={(e) => handleChange(e, row.uuid)}
            name="consumptionpart"
          />
        ) : (
          row.consumptionpart
        ),
    },
    {
      name: "Rendement d'impacts / Valeur caractéristique de performance",
      selector: (row) => row.devicecaracteristicval,
      sortable: true,
      cell: (row) =>
        editableRowId === row.uuid ? (
          <IntInput
            //inputTitle={actionVar[params].observations}
            intInput={newData[indexFinder(row.uuid)].devicecaracteristicval}
            handleIntInputChange={(e) => handleChange(e, row.uuid)}
            name="devicecaracteristicval"
          />
        ) : (
          row.devicecaracteristicval
        ),
    },
    {
      name: "Unité",
      selector: (row) => row.devicecaracteristicunit,
      sortable: true,
      maxWidth: "8rem",
      cell: (row) =>
        editableRowId === row.uuid ? (
          <TextInput
            //inputTitle={actionVar[params].observations}
            textInput={newData[indexFinder(row.uuid)].devicecaracteristicunit}
            handleTextInputChange={(e) => handleChange(e, row.uuid)}
            name="devicecaracteristicunit"
          />
        ) : (
          row.devicecaracteristicunit
        ),
    },
    {
      name: "Coût unitaire d'installation (€)",
      selector: (row) => row.installationcost,
      sortable: true,
      cell: (row) =>
        editableRowId === row.uuid ? (
          <IntInput
            //inputTitle={actionVar[params].observations}
            intInput={newData[indexFinder(row.uuid)].installationcost}
            handleIntInputChange={(e) => handleChange(e, row.uuid)}
            name="installationcost"
          />
        ) : (
          row.installationcost
        ),
    },
    actionplanupdate && {
      name: "",
      sortable: false,
      width: "4rem",
      // eslint-disable-next-line react/button-has-type
      // eslint-disable-next-line react/display-name
      cell: (row) =>
        action.parameters.impact.equipments.some((x) => x.uuid == row.uuid) && (
          <>
            <div className="actions-right">
              <Tooltip title="Editer">
                <Button
                  onClick={editEnabled(row)}
                  color={editableRowId === row.uuid ? "info" : "success"}
                  className={classes.actionButton}
                >
                  {editableRowId === row.uuid ? (
                    <CheckIcon fontSize="large" />
                  ) : (
                    <EditIcon fontSize="large" />
                  )}
                </Button>
              </Tooltip>
            </div>
          </>
        ),
      cell: (row) => (
        <>
          <div className="actions-right">
            <Tooltip title="Editer">
              <Button
                onClick={editEnabled(row)}
                color={editableRowId === row.uuid ? "info" : "success"}
                className={classes.actionButton}
              >
                {editableRowId === row.uuid ? (
                  <CheckIcon fontSize="large" />
                ) : (
                  <EditIcon fontSize="large" />
                )}
              </Button>
            </Tooltip>
          </div>
        </>
      ),
    },
  ];

  const handleChange = (e, id) => {
    const { name, value } = e.target;
    console.log(e.target);
    const indexOfId = newData.findIndex((obj) => obj.uuid == id);

    let newArray = [...newData];
    newArray[indexOfId][name] = value;

    setNewData(newArray);
  };

  const handleSelectedChange = ({ selectedRows }) => {
    if (actionplanupdate) {
      selectedRows.map((equipment) => (equipment.isSelected = true));
      setAction((prevState) => ({
        ...prevState,
        parameters: {
          ...prevState.parameters,
          impact: {
            ...prevState.parameters?.impact,
            equipments: selectedRows,
          },
        },
      }));
    }
  };

  const editEnabled = (row) => async () => {
    editableRowId === row.uuid
      ? setEditableRowId(null)
      : setEditableRowId(row.uuid);
  };

  const reloadEquipment = (row) => async () => {
    let equipments = [...action.parameters.impact.equipments];

    let updatedEquipments = equipments.filter((item) => item.uuid !== row.uuid);

    setAction((prevState) => ({
      ...prevState,
      parameters: {
        ...prevState.parameters,
        impact: {
          ...prevState.parameters?.impact,
          equipments: updatedEquipments,
        },
      },
    }));

    refreshTable();
  };

  const contextMessage = {
    singular: "équipement",
    plural: "équipements",
    message: "sélectionné(s)",
  };

  const selectableRowDisabled = (row) => {
    if (!actionplanupdate) {
      return row;
    }
  };

  const rowSelectCritera = (row) => row.isSelected == true;
  return (
    <>
      <DataTable
          paginationRowsPerPageOptions={[10,20,30,50,100]}
        //noHeader={true}
        //title="Liste des equipements"
        noDataComponent="Aucun équipement retrouvé dans le patrimoine"
        columns={columns}
        persistTableHead
        subHeader
        progressPending={gridState.loading}
        progressComponent={<LinearProgress />}
        highlightOnHover
        dense
        selectableRows
        onSelectedRowsChange={handleSelectedChange}
        selectableRowSelected={rowSelectCritera}
        selectableRowsHighlight
        selectableRowDisabled={selectableRowDisabled}
        {...gridState}
        contextMessage={contextMessage}
      />
    </>
  );
};

export default RTEquipments;
